import React, { useState, useEffect } from 'react';
import { mockOpenJobs } from '../../../AppData';

const CBSEJobBannerCreator = (props) => {
  const [loading, setLoading] = useState(false);
  
  // Mock job data from PDF
  /*const mockOpenJobs = [
    { jobPostingID: 'JOB001', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'KG Teacher', subject: 'Early Education', qualification: 'Any Degree & NTT/Montessori or D.El.Ed.', noOfPositions: 9, workLocation: 'Dindigul', removalDate: '2026-01-31', gender:'Female' },
    { jobPostingID: 'JOB002', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'PRT', subject: 'Tamil', qualification: 'B.A. / B. Lit., B.Ed.', noOfPositions: 3, workLocation: 'Dindigul', removalDate: '2026-01-31', gender:'Male/Female' },
    { jobPostingID: 'JOB003', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'PRT', subject: 'English', qualification: 'B.A. English, B.Ed.', noOfPositions: 2, workLocation: 'Dindigul', removalDate: '2026-01-31', gender:'Male/Female' },
    { jobPostingID: 'JOB004', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'PRT', subject: 'Maths', qualification: 'B.Sc. Maths, B.Ed.', noOfPositions: 5, workLocation: 'Dindigul', removalDate: '2026-01-31', gender:'Male/Female' },
    { jobPostingID: 'JOB005', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'PRT', subject: 'EVS', qualification: 'B.Sc. Physics/Chemistry/Botany/Zoology, B.Ed.', noOfPositions: 3, workLocation: 'Dindigul', removalDate: '2026-01-31', gender:'Male/Female' },
    { jobPostingID: 'JOB006', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'PRT', subject: 'Computer Science', qualification: 'B.Sc. Computer Science / BCA, B.Ed.', noOfPositions: 2, workLocation: 'Dindigul', removalDate: '2026-01-31', gender:'Male/Female' },
    { jobPostingID: 'JOB007', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'PRT', subject: 'Hindi', qualification: 'B.A (Hindi), B.Ed.', noOfPositions: 1, workLocation: 'Dindigul', removalDate: '2026-01-31', gender:'Male/Female' },
    { jobPostingID: 'JOB008', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'TGT', subject: 'English', qualification: 'B.A.(English), B.Ed.', noOfPositions: 1, workLocation: 'Dindigul', removalDate: '2026-01-31', gender:'Male/Female' },
    { jobPostingID: 'JOB009', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'TGT', subject: 'Tamil', qualification: 'B.A. / B. Lit., B.Ed.', noOfPositions: 1, workLocation: 'Dindigul', removalDate: '2026-01-31', gender:'Male/Female' },
    { jobPostingID: 'JOB010', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'TGT', subject: 'Maths', qualification: 'B.Sc. Maths, B.Ed.', noOfPositions: 3, workLocation: 'Dindigul', removalDate: '2026-01-31', gender:'Male/Female' },
    { jobPostingID: 'JOB011', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'TGT', subject: 'Physics', qualification: 'B.Sc. Physics, B.Ed.', noOfPositions: 1, workLocation: 'Dindigul', removalDate: '2026-01-31', gender:'Male/Female' },
    { jobPostingID: 'JOB012', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'TGT', subject: 'Biology', qualification: 'B.Sc. Botany/Zoology, B.Ed.', noOfPositions: 1, workLocation: 'Dindigul', removalDate: '2026-01-31', gender:'Male/Female' },
    { jobPostingID: 'JOB013', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'TGT', subject: 'Social Science', qualification: 'B.A. History/Geography/ Economics, B.Ed.', noOfPositions: 1, workLocation: 'Dindigul', removalDate: '2026-01-31', gender:'Male/Female' },
    { jobPostingID: 'JOB014', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'PRT', subject: 'Fine Arts', qualification: 'B.F.A / B.Sc. VisCom', noOfPositions: 1, workLocation: 'Dindigul', removalDate: '2026-01-31', gender:'Male/Female' },
    { jobPostingID: 'JOB015', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'PET', subject: 'Physical Education', qualification: 'B.P.Ed.', noOfPositions: 1, workLocation: 'Dindigul', removalDate: '2026-01-31', gender:'Female' },
    { jobPostingID: 'JOB016', schoolName: 'Loyola Tech School (CBSE)', positionApplied: 'Counsellor', subject: 'Guidance & Counselling', qualification: 'B.A / B.Sc. Psychology', noOfPositions: 1, workLocation: 'Dindigul', removalDate: '2026-01-31', gender:'Female' }
  ];*/

  const { openJobs = mockOpenJobs, handleRoute } = props;

  const formatDate = (date) =>
  new Date(date)
    .toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
    .replace(/ /g, "-");

  return (
    <div className="container-fluid py-2 bg-dark min-vh-50 d-flex align-items-center">
      <style>
        {`
          .marquee-container {
            overflow: hidden;
            white-space: nowrap;
            position: relative;
            padding: 10px 0;
          }

          .marquee-content {
            display: inline-flex;
            animation: scroll 30s linear infinite;
          }

          .marquee-content:hover {
            animation-play-state: paused;
          }

          @keyframes scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }

          .job-card {
            width: 380px;
            margin-right: 25px;
            border: none;
            border-radius: 15px;
            background: #ffffff;
            transition: transform 0.3s ease;
            white-space: normal; /* Allows text to wrap inside the card */
          }

          .job-card:hover {
            transform: translateY(-10px);
          }

          .card-accent {
            height: 6px;
            background: linear-gradient(90deg, #0d6efd, #6610f2);
            border-radius: 15px 15px 0 0;
          }
        `}
      </style>

      <div className="w-100">
       {/*} <div className="text-center mb-5 text-white">
          <h2 className="fw-bold text-uppercase tracking-widest">Active Openings</h2>
         {/*} <div className="badge bg-primary">Live Database Updates</div>
        </div>*/}

        {loading ? (
          <div className="text-center text-white">
            <div className="spinner-border" role="status"></div>
          </div>
        ) : (
          <div className="marquee-container">
            {/* We double the array to create a seamless infinite loop */}
            <div className="marquee-content">
              {[...openJobs, ...openJobs].map((job, index) => (
                <div key={`${job.jobPostingID}-${index}`} className="job-card shadow-lg">
                  <div className="card-accent"></div>
                  <div className="card-body p-4">
                    <div className="d-flex justify-content-between mb-3">
                      <span className="badge rounded-pill bg-light text-primary border border-primary px-3"> Job ID : {job.jobPostingID}</span>
                      <small className="text-danger fw-bold">Ends: {formatDate(job.removalDate)}</small>
                    </div>
                    
                    <h5 className="text-muted small mb-1">{job.schoolName}</h5>
                    <h3 className="h5 fw-bold mb-3">{job.positionApplied} - <span className="text-primary">{job.subject}</span></h3>
                    
                    <div className="mb-3 p-2 bg-light rounded">
                      <small className="d-block text-muted mb-1">Qualification</small>
                      <small className="d-block fw-bold text-dark">{job.qualification}</small>
                    </div>
                    
                    <div className="row g-0 py-3 border-top border-bottom mb-3">
                      <div className="col-6">
                        <small className="d-block text-muted">Vacancies</small>
                        <span className="fw-bold">{job.noOfPositions} Position(s)</span>
                      </div>
                      <div className="col-6">
                        <small className="d-block text-muted">Location</small>
                        <span className="fw-bold text-truncate d-block small">{job.workLocation}</span>
                      </div>
                    </div>

                    <div className="mb-3">
                      <small className="d-block text-muted">Gender</small>
                      <span className="fw-bold">{job.gender}</span>
                    </div>

                    <button className="btn btn-outline-primary w-100 rounded-pill fw-bold" onClick={event=>handleRoute(event,job)}>Apply Now</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CBSEJobBannerCreator;